export const TEST_ID = 'serviceIntervalsForm';
